<template>
  <ion-page>
    <Background></Background>
    <FabColumn>
      <AboutButton back_url="LoginPrepare"></AboutButton>
    </FabColumn>
    <ion-content>
      <div class="flow-content login-prepare-flow">
        <PrepareTips class="prepare-tips"></PrepareTips>
        <ConfirmButton class="prepare-button" text="開始使用" position="relative" @click="goLogin"></ConfirmButton>
        <div class="prepare-organization">
          <LaunchSponsor class="prepare-sponsor"></LaunchSponsor>
          <LaunchDonate class="prepare-donate"></LaunchDonate>
        </div>
      </div>
    </ion-content>

  </ion-page>
</template>

<script>
import {IonContent, IonPage} from "@ionic/vue";
import Background from "../components/common/Background";
import PrepareTips from "../components/common/PrepareTips";
import LaunchSponsor from "../components/launch/LaunchSponsor";
import LaunchDonate from "../components/launch/LaunchDonate";
import router from "../router";
import AboutButton from "../components/common/AboutButton";
import ConfirmButton from "../components/common/ConfirmButton";

export default {
  name: "LoginPrepare",
  components: {
    ConfirmButton,
    AboutButton,
    LaunchDonate,
    LaunchSponsor,
    PrepareTips,
    Background,
    IonPage,
    IonContent
  },
  methods: {
    goLogin: function () {
      router.replace('/login')
    }
  }
}
</script>

<style scoped>
.login-prepare-flow {
  display: block;
  height: 100dvh;
  min-height: 0;
  overflow: hidden;
  padding: 0;
}

.prepare-tips :deep(.title) {
  margin-top: 20vh;
  font-size: 6vh;
}

.prepare-tips :deep(.sub-title) {
  margin: 3.2vh auto;
  font-size: 3.8vh;
}

.prepare-button {
  display: block;
  width: 47vh;
  margin: 4vh auto;
  max-width: none;
  text-align: center;
}

.prepare-button :deep(.box) {
  display: block;
  width: 100%;
  max-width: none;
  margin-left: auto;
  margin-right: auto;
}

.prepare-button :deep(.button) {
  display: block;
  width: 100%;
  height: 12vh;
  min-height: 12vh;
  margin-left: auto;
  margin-right: auto;
  font-size: 3.8vh;
  --padding-top: 0;
  --padding-bottom: 0;
}

.prepare-organization {
  position: relative;
  display: block;
  width: 100%;
  margin-top: 12vh;
  text-align: center;
}

.prepare-sponsor,
.prepare-donate {
  box-sizing: border-box;
  display: inline-block;
  margin: auto 6%;
}

.prepare-sponsor {
  height: 12vh;
  padding-top: 2vh;
}

.prepare-donate {
  height: 14vh;
  padding-top: 0;
}

.prepare-sponsor :deep(.text),
.prepare-donate :deep(.text) {
  margin-bottom: 0;
  font-size: 2vh;
}

.prepare-sponsor :deep(.img) {
  width: auto;
  height: 80%;
  margin-top: 1vh;
}

.prepare-donate :deep(.img) {
  width: auto;
  height: 60%;
  margin-top: 1vh;
}

@media (orientation: landscape) and (max-height: 480px) {
  .prepare-tips :deep(.title) {
    margin-top: 20vh;
    font-size: 6vh;
  }

  .prepare-tips :deep(.sub-title) {
    margin: 3.2vh auto;
    font-size: 3.8vh;
  }

  .prepare-button {
    margin: 4vh auto;
  }

  .prepare-organization {
    margin-top: 12vh;
  }
}
</style>
